import React from 'react';

import { CheckoutPage as Checkout } from 'modules/checkoutModule/screens';
import AuthPage from '../../common/components/AuthPage';

const CheckoutPage = () => (
  <AuthPage>
    <Checkout />
  </AuthPage>
);

export default CheckoutPage;
